<template>
    <form
        v-on:submit="handleSubmit"
    >
        <input-text-field
            :vuelidate="v$.formData.name"
            id="name"
            label="First Name"
        ></input-text-field>
        <input-text-field
            :vuelidate="v$.formData.last_name"
            id="last_name"
            label="Last Name"
        ></input-text-field>
        <input-text-field
            :vuelidate="v$.formData.meta.instagram"
            id="instagram"
            label="Instagram"
        ></input-text-field>
<!--        <password-field-->
<!--            v-if="!user"-->
<!--            :vuelidate="v$.formData.password"-->
<!--            id="password"-->
<!--            label="Password"-->
<!--        ></password-field>-->
        <input-text-field
            :vuelidate="v$.formData.address_phone"
            id="address_phone"
            label="Phone"
            placeholder="555-555-5555"
        ></input-text-field>
        <input-text-field
            :vuelidate="v$.formData.address_zip"
            id="address_zip"
            label="Zip"
        ></input-text-field>
        <input-text-field
            :vuelidate="v$.formData.coupon"
            id="coupon"
            label="Coupon"
        ></input-text-field>
        <checkbox-field
            :vuelidate="v$.formData.subscribe_to_njm_newsletter"
            id="subscribe_to_njm_newsletter"
            label="Yes, I want to receive weekly newsletters from New Jersey Monthly about the latest restaurant news, things to do, Jersey Shore and more."
        ></checkbox-field>
        <checkbox-field
            :vuelidate="v$.formData.subscribe_to_sponsored_newsletter"
            id="subscribe_to_sponsored_newsletter"
            label="Yes, please send me expert photography advice and information from Unique Photo."
        ></checkbox-field>
        <checkbox-field
            :vuelidate="v$.formData.purchase_njm_magazine_subscription"
            id="purchase_njm_magazine_subscription"
            label="Yes, I would like to subscribe to New Jersey Monthly magazine for one year for only $5."
        ></checkbox-field>
        <div
            v-if="state.formData.purchase_njm_magazine_subscription"
        >
            <input-text-field
                :vuelidate="v$.formData.address_line1"
                id="address_line1"
                label="Address"
            ></input-text-field>
            <input-text-field
                :vuelidate="v$.formData.address_city"
                id="address_city"
                label="City"
            ></input-text-field>
            <input-text-field
                :vuelidate="v$.formData.address_state"
                id="address_state"
                label="State"
            ></input-text-field>
        </div>
        <div>
            <div>
                <checkbox-field
                    :vuelidate="v$.formData.save_card_info"
                    id="save_card_info"
                    label="Yes, I would like New Jersey Monthly to securely save my card information for
                        future entries."
                ></checkbox-field>
            </div>
            <div v-if="!couponCodeFree" class="field">
                <label for="example2-card-number">Card number</label>
                <div id="example2-card-number" class="input text empty StripeElement"></div>
                <div class="baseline"></div>
            </div>
        </div>

        <div id="card-errors" role="alert"></div>

        <div class="text-center_content full-width">
            <span
                class="scroll btn btn-primary"
                :class="{ 'opacity-50': v$.$invalid }"
                v-on:click="handleSubmit"
            >
                Complete Submission
            </span>
        </div>
    </form>
</template>
<script setup>
import { email, required, requiredIf, numeric } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import InputTextField from "@/js/components/fields/InputTextField";
import CheckboxField from "@/js/components/fields/CheckboxField";
import PasswordField from "@/js/components/fields/PasswordField";
import { reactive, computed, onMounted, nextTick} from "vue";
import { useStore } from 'vuex'
import {ENV_URL, STRIPE_PUBLISHABLE} from "../../environment";
import queryString from "qs";
import { useRouter, useRoute } from 'vue-router'
import {isEmpty} from "lodash";
const router = useRouter()
const route = useRoute()
const isBrowser = typeof window !== 'undefined';
const stripe = window.Stripe(STRIPE_PUBLISHABLE);
const elements = stripe.elements();
const elementStyles = {
    base: {
        color: '#32325D',
        fontWeight: 500,
        fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
        fontSize: '16px',
        fontSmoothing: 'antialiased',

        '::placeholder': {
            color: '#CFD7DF',
        },
        ':-webkit-autofill': {
            color: '#e39f48',
        },
    },
    invalid: {
        color: '#E25950',

        '::placeholder': {
            color: '#FFCCA5',
        },
    },
};

var elementClasses = {
    focus: 'focused',
    empty: 'empty',
    invalid: 'invalid',
};
const card = elements.create('card', {
    style: elementStyles,
    classes: elementClasses,
    hidePostalCode: true
});

const store = useStore()
const state = reactive({
    hidePaymentForm: false,
    formData: {
        name: '',
        last_name: '',
        email: '',
        meta: {
            instagram: '',
        },
        password: '',
        address_phone: '',
        address_zip: '',
        id: '',
        subscribe_to_njm_newsletter: true,
        subscribe_to_sponsored_newsletter: true,
        purchase_njm_magazine_subscription: false,
        address_line1: '',
        address_city: '',
        address_state: '',
        coupon: '',
        save_card_info: false,
    },
    formDataTest: {
        name: 'Test',
        last_name: 'User',
        email: 'testuser@email.com',
        meta: {
            instagram: 'Instagram',
        },
        password: 'password',
        address_phone: '555-555-5555',
        address_zip: '22222',
        id: '',
        subscribe_to_njm_newsletter: true,
        subscribe_to_sponsored_newsletter: true,
        purchase_njm_magazine_subscription: true,
        address_line1: '111 Main St',
        address_city: 'Morristown',
        address_state: 'NJ',
        coupon: '',
        save_card_info: false,
    },
});
const props = defineProps({
    submitForm: {
        type: Function,
        required: true,
    },
    prefillFormData: {
        type: Object,
        default: {},
    }
})
const notRequired = () => true;
const rules =  {
    formData: {
        name: { required },
        last_name: { required },
        meta: {
            instagram: {
                notRequired,
            }
        },
        password: { required: requiredIf(() =>  !user.value) },
        address_phone: { required },
        address_zip: {
            required,
            numeric,
        },
        coupon: {
            notRequired,
        },

        id: {
            notRequired,
        },
        subscribe_to_njm_newsletter: {
            notRequired,
        },
        subscribe_to_sponsored_newsletter: {
            notRequired,
        },
        purchase_njm_magazine_subscription: {
            notRequired,
        },
        address_line1: {
            required: requiredIf(() => state.formData.purchase_njm_magazine_subscription),
        },
        address_city: {
            required: requiredIf(() => state.formData.purchase_njm_magazine_subscription),
        },
        address_state: {
            required: requiredIf(() => state.formData.purchase_njm_magazine_subscription),
        },
        save_card_info: {
            notRequired,
        }
    }
}
const v$ = useVuelidate(rules, state);

const contest = computed(() => store.state.contest)
const loading = computed(() => store.state.loading)
const entry = computed(() => store.state.entry)
const user = computed(() => store.state.user)
const couponCodeFree = computed(() => state.formData.coupon === 'njstudent23')

const getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}


const handleSubmit = () => {
    if (loading.value || v$.value.$invalid) {
        v$.value.$touch();
        return;
    }
    store.dispatch('LOADING', true);
    let authHeaders = {};
    let query = Object.assign({}, route.query);
    const search = queryString.stringify(query) ? '?' + queryString.stringify(query) : '';
    let uri = '';
    // If the user is logged in, include the JWT in the auth headers
    // when posting the data to the server. This will authenticate him.
    if (user.value) {
        var laravelAuthToken = localStorage.getItem('laravelAuthToken');
        authHeaders = {
            headers: {"Authorization": `Bearer ${laravelAuthToken}`}
        };
        uri = `${ENV_URL}/contests/${ contest.value.slug }/entries/${ entry.value.id }/purchase${search}`;
    }
    // Include the data from the user form and the coupon field
    let data = {};
    data.formData = state.formData;
    data.hubspotutk = getCookie('hubspotutk')
    data.purchaseData = {
        hubspotutk: getCookie('hubspotutk')
    };
    if (couponCodeFree.value) {
        props.submitForm(uri, data, authHeaders);
    } else {
        // Get the user's info for Stripe
        let stripeData = {
            name: state.formData.name,
            last_name: state.formData.last_name,
            email: state.formData.email,
            address_phone: state.formData.address_phone,
            address_zip: state.formData.address_zip,
        };
        stripe.createToken(card, {
            stripeData
        }).then(function (result) {
            if (result.error) {
                store.dispatch('LOADING', false);
                // Inform the customer that there was an error
                var errorElement = document.getElementById('card-errors');
                errorElement.textContent = result.error.message;
                return false;
            } else {

                data.purchaseData = {
                    source: result.token.id,
                    hubspotutk: getCookie('hubspotutk'),
                };
                props.submitForm(uri, data, authHeaders);
            }
        });
    }

}

const asyncMountCard = async () => {
    await nextTick();
    if (Boolean(contest) && Boolean(contest.settings)) {
        contest.settings["free"] ? state.hidePaymentForm = true : "";
    }
    card.mount('#example2-card-number');
    // Handle real-time validation errors from the card Element.
    card.addEventListener('change', function (event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) {
            displayError.textContent = event.error.message;
        } else {
            displayError.textContent = '';
        }
    });
}
const mountCard = async () => {
    await asyncMountCard();
}
onMounted(() => {
    mountCard();
    // state.formData = state.formDataTest;
})
</script>